/* eslint no-undef: 0 */ // --> OFF, because of document undeined and window undefined
export const getWindow = () => window;
export const getDocument = () => document || window.document;

export const getJSON = selector => JSON.parse(getDocument().querySelector(selector).innerHTML);
export default null;
